module.exports = __webpack_public_path__ + "static/media/send-letter-info-img1.e0001531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-info-img1.png
// module id = 1312
// module chunks = 1